import { CommaEncodeChar } from "./CommaEncodeChar";

export function CommaEncode(str) {
  if (typeof str != "string") return str;

  var n = str.length;
  var encodeStr = "";
  for (var i = 0; i < n; i++) {
    var c = str[i];
    c = CommaEncodeChar(c);
    encodeStr += c;
  }

  return encodeStr;
}
